module.exports = __webpack_public_path__ + "assets/img/11november_dark.f92f90bf.jpeg";